import { Building2 } from 'lucide-react';

const InventoryBranchEmpty = () => {
  return (
    <div
      className="
        flex
        min-h-[320px]
        flex-col
        items-center
        justify-center

        px-6

        text-center
      "
    >
      <span
        className="
          rounded-xl

          border
          border-stroke

          bg-gray-2

          p-4

          text-bodydark2

          dark:border-strokedark
          dark:bg-meta-4
          dark:text-bodydark
        "
      >
        <Building2 className="h-8 w-8" />
      </span>

      <h1
        className="
          mt-4

          text-lg
          font-semibold
          text-black

          dark:text-white
        "
      >
        No hay sucursales disponibles
      </h1>

      <p
        className="
          mt-1
          max-w-md

          text-sm
          text-bodydark2

          dark:text-bodydark
        "
      >
        Configure una sucursal para administrar el inventario
        de materia prima.
      </p>
    </div>
  );
};

export default InventoryBranchEmpty;